// extracted by mini-css-extract-plugin
export default {"List":"SubcontractsList_List__34MBR"};